import axios from 'axios';

export const folderService = {
  rename(id, newName) {
    return axios.post('/api/documents/rename/', { IsFolder: true, ObjectID: id, ObjectType: 'fod', NewName: newName });
  }
};